export const enClientPortalAssetPageLayout = {
    sectionLabel: 'ASSET',
}
